module.exports = "/images/vendor/flag-icon-css/flags/1x1/qa.svg?78909a6f9bc32e8d2bb779b121cb0630";